import styled from 'styled-components';

export const Puchases_loans = styled.div`

`;

export const Spinners = styled.div`
.spinner-border {
   width: 2rem;
   height: 2rem;
   color: ${props => props.theme.colors.primary} !important;
}
`;